import { create } from 'zustand';
import { usersApi } from '../lib/apiClient';
import { User } from '../types/user';
import { CreateUserDto } from '../types/types';

interface UsersState {
  users: User[];
  setUsers: (users: User[]) => void;
  fetchUsers: () => Promise<User[]>;
  createUser: (payload: CreateUserDto | any) => Promise<User>;
  updateUser: (id: string, payload: any) => Promise<User>;
  deleteUser: (id: string) => Promise<void>;
  activateUser: (id: string, roleId?: number) => Promise<User>;
}

export const useUsersStore = create<UsersState>((set, get) => ({
  users: [],
  setUsers: (users) => set({ users }),
  fetchUsers: async () => {
    const list = await usersApi.list();
    set({ users: Array.isArray(list) ? list : [] });
    return get().users;
  },
  createUser: async (payload) => {
    const created = await usersApi.create(payload);
    set((state) => ({ users: [...state.users, created] }));
    return created;
  },
  updateUser: async (id, payload) => {
    const updated = await usersApi.update(id, payload);
    set((state) => ({ users: state.users.map(u => (u.id === id ? updated : u)) }));
    return updated;
  },
  deleteUser: async (id) => {
    await usersApi.delete(id);
    set((state) => ({ users: state.users.filter(u => u.id !== id) }));
  },
  activateUser: async (id, roleId) => {
    const activated = await usersApi.activate(id, roleId);
    set((state) => ({ users: state.users.map(u => (u.id === id ? activated : u)) }));
    return activated;
  }
}));
